import React, { useEffect, useState } from "react";
import "./MessageDetail.css";
import { getDetails } from "../../../Utils/Utils";
import { FaUser, FaEnvelope, FaPhone, FaImage } from "react-icons/fa";

function formatUtilityPrice(price) {
  if (price == null || price === "") return "—";
  const n = Number(price);
  return Number.isFinite(n) ? `$${n.toFixed(2)}` : String(price);
}

const MessageDetail = ({loading, post, message}) => {
  const [selectedImage, setSelectedImage] = useState(post?.image_url?.split(",")[0]);

  useEffect(() => {
    if (post?.image_url) {
      setSelectedImage(post.image_url.split(",")[0]);
    }
  }, [post]);


  if (loading) {
    return (
      <div className="message-detail-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading message details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="message-detail-container">
      {/* Message Header */}
      <div className="message-detail-header">
        <div className="header-content">
          <div className="message-info">
            <div className="sender-avatar">
              {message.postImage ? (
                <img src={message.postImage} alt={message.name} />
              ) : (
                <div className="avatar-placeholder">
                  <FaUser />
                </div>
              )}
            </div>
            <div className="sender-details">
              <h2>{message.name}</h2>
              <p>Interested in your listing</p>
            </div>
          </div>
          {/* <div className="message-actions">
            <button 
              className={`action-btn favorite-btn ${isFavorited ? 'active' : ''}`}
              onClick={() => setIsFavorited(!isFavorited)}
            >
              <FaHeart />
            </button>
            <button className="action-btn reply-btn">
              <FaReply />
              Reply
            </button>
            <button className="action-btn share-btn">
              <FaShare />
            </button>
          </div> */}
        </div>
      </div>

      {/* Message Content */}
      <div className="message-detail-content">
        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-grid">
            <div className="contact-item">
              <FaUser />
              <div>
                <label>Name</label>
                <span>{message.name}</span>
              </div>
            </div>
            <div className="contact-item">
              <FaEnvelope />
              <div>
                <label>Email</label>
                <span>{message.email}</span>
              </div>
            </div>
            <div className="contact-item">
              <FaPhone />
              <div>
                <label>Contact</label>
                <span>{message.contact}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Message */}
        <div className="message-section">
          <div className="message-content">
            <p><strong>Message:</strong> {message.message}</p>
          </div>
        </div>

        {/* Post Details */}
        <div className="post-section">
          {/* Image Gallery */}
          {post?.image_url && (
            <div className="image-gallery">
              <div className="main-image-container">
                {selectedImage ? (
                  <img src={selectedImage} alt="Selected" className="main-image" />
                ) : (
                  <div className="image-placeholder">
                    <FaImage />
                    <p>No image available</p>
                  </div>
                )}
              </div>
              
              {post.image_url.split(",").length > 1 && (
                <div className="thumbnail-container">
                  {post.image_url.split(",").map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Thumbnail ${index}`}
                      className={`thumbnail ${selectedImage === img ? "selected" : ""}`}
                      onClick={() => setSelectedImage(img)}
                    />
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Post Details Grid */}
          {post?.created_date && (() => {
            const details = getDetails(post);
            const utilities = Array.isArray(details?.Utilities) ? details.Utilities : [];
            return (
              <div className="post-details-grid">
                <h4>Post Details</h4>
                {Object.entries(details)
                  .filter(([key]) => key !== "Utilities")
                  .map(([key, value], index) => (
                    <div key={index} className="detail-item">
                      <span className="detail-label">{key}</span>
                      <span className="detail-value">{value ?? "N/A"}</span>
                    </div>
                  ))}
                {utilities.length > 0 && (
                  <div className="utilities-section">
                    <h4 className="utilities-heading">Utilities</h4>
                    <table className="utilities-table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Price</th>
                          <th>Store</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {utilities.map((u) => (
                          <tr key={u.id ?? `${u.name}-${u.storeLink}`}>
                            <td>{u.name || "—"}</td>
                            <td>{formatUtilityPrice(u.price)}</td>
                            <td>
                              {u.storeLink ? (
                                <a href={u.storeLink} target="_blank" rel="noopener noreferrer">
                                  Link
                                </a>
                              ) : (
                                "—"
                              )}
                            </td>
                            <td>{u.availabilityStatus || "—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
};

export default MessageDetail;
